import React from "react";
import Image from "../Tags/Image";

export default function SplashCard({ mediaSrc, heading, info, link }) {
  return (
    <div className="border border-border rounded-[14px] overflow-hidden bg-background p-5">
      <div className="flex justify-center">
        <Image className="no-invert" src={mediaSrc} />
      </div>
      <div className="space-y-3 mt-5">
        <h2 className="font-semibold">{heading}</h2>
        <p>{info}</p>
        {link && <div>{link}</div>}
      </div>
    </div>
  );
}
